import * as React from 'react';
import { IconicPromoLink } from './iconic_promo_link';
import { IPromoLink } from '../../../types/promo';

interface IProps {
  id: string;
  title: string;
  titleLink?: IPromoLink;
  backgroundClassName: string;
  blockClassName: string;
}

const s = require('../vertical_promo_blocks.css');

export class BsPromoBlock extends React.Component<IProps> {
  public render() {
    return (
      <div
        className={`${s['c-new-promo-block']}
                        ${s[this.props.backgroundClassName]}
                        ${this.props.blockClassName}`}
      >
        <div
          className={`${s['c-new-promo-block-content']}
                      ${s['c-new-promo-block-content-link-icon']}`}
        >
          <IconicPromoLink
            rootTitle={this.props.title}
            id={this.props.id}
            url={this.props.titleLink && this.props.titleLink.url}
          />
        </div>
      </div>
    );
  }
}
